var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCro1381CardVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 31,
    viewBox: "0 0 51 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.541829,
    y: 1.1036,
    width: 49.5833,
    height: 29.5833,
    rx: 6.45833,
    fill: "#FAFAFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.541829,
    y: 1.1036,
    width: 49.5833,
    height: 29.5833,
    rx: 6.45833,
    stroke: "#495157",
    strokeWidth: 0.416667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.164 19.4537C26.9804 19.4537 26.3314 19.2908 25.3348 18.8796L24.9655 18.7105L24.5468 21.1544C25.2668 21.4523 26.5647 21.7083 27.9075 21.7285C31.0611 21.7285 33.1223 20.2591 33.147 17.9982C33.1717 16.7553 32.359 15.8119 30.6424 15.0345C29.6009 14.5302 28.952 14.1919 28.952 13.6798C28.952 13.2267 29.5067 12.7442 30.6655 12.7442C31.4356 12.7256 32.2012 12.8677 32.9137 13.1616L33.1918 13.2857L33.6106 10.924L33.5379 10.9395C32.6756 10.6287 31.7656 10.4727 30.8494 10.4787C27.8827 10.4787 25.7891 11.959 25.7736 14.0802C25.7551 15.6396 27.2631 16.5179 28.4019 17.0408C29.5716 17.5762 29.9625 17.9129 29.9594 18.3939C29.9517 19.1248 29.0246 19.4537 28.164 19.4537ZM41.2374 10.6789H38.9197C38.1981 10.6789 37.6588 10.8728 37.3421 11.5835L32.8844 21.5764H36.038L36.6684 19.941L40.5158 19.9441C40.61 20.3258 40.8866 21.5764 40.8866 21.5764H43.6663L41.2374 10.6789ZM37.5321 17.705L38.7281 14.659C38.7126 14.69 38.9753 14.029 39.1267 13.6193L39.3322 14.5597L40.026 17.705H37.5321ZM19.6302 21.4896H22.6339L24.5112 10.5873H21.509V10.5842L19.6302 21.4896ZM14.1897 18.1099L13.8776 16.5955V16.6001L12.8238 11.5944C12.643 10.9007 12.1146 10.6959 11.4595 10.6711H6.62164L6.58301 10.9007C7.67233 11.1568 8.65349 11.5276 9.53113 11.9823C9.66742 12.0623 9.76721 12.1926 9.80926 12.3454L12.4051 21.5609H15.5788L20.3085 10.6789H17.127L14.1897 18.1099Z",
    fill: "#191E6E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCro1381CardVisa);
export default __webpack_public_path__ + "static/media/cro1381-card-visa.ff3070d7.svg";
export { ForwardRef as ReactComponent };